export default __webpack_public_path__ + "static/media/type-simple.0a879415.PNG";